import React from 'react';

export default function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between mb-6 pb-4 border-b border-slate-200">
      <div>
        {overline && <div className="text-[10px] font-display font-bold uppercase tracking-[0.2em] text-[#3b4872] mb-2">{overline}</div>}
        <h1 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-slate-600 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
